// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tax_invoice_request_detail_pop .content_box[data-v-da9c8d34] {\n  height: auto !important;\n  min-height: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
